import z from "zod";

export const CreateEmployeeTimeSheetSchema = z
    .object({
        project_id: z.string().min(1, "Project ID is required"),
        supplier_id: z.string().min(1, "Supplier ID is required"),
        mobilized: z
            .array(
                z.object({
                    employee_id: z.string().min(1, "Employee ID is required"),
                    date_logs: z
                        .array(
                            z.object({
                                id: z.string(),
                                log_date: z.string().min(1, "Date is required"),
                                hours: z.number({
                                    required_error: "Hour is required",
                                    invalid_type_error:
                                        "Hour must be a valid number",
                                }),
                                status: z.enum([
                                    "ABSENT",
                                    "PRESENT",
                                    "SICK_LEAVE",
                                    "HOLIDAY",
                                    "NOT_MOBILIZED",
                                    "DAY_OFF",
                                    "RELEASED",
                                    "VACATION",
                                    "PUNCH_MISS",
                                ]),
                            }),
                        )
                        .min(1, "At least one date log is required"),
                }),
            )
            .min(1, "At least one mobilized employee is required"),
    })
    .refine(
        (data) =>
            data.mobilized.every((emp) =>
                emp.date_logs.every((log) => log.hours >= 0 && log.hours <= 24),
            ),
        {
            message: "Each hour value must be between 0 and 24.",
            path: ["mobilized"],
        },
    );

export type CreateEmployeeTimeSheetSchema = z.infer<
    typeof CreateEmployeeTimeSheetSchema
>;

export const GenerateTimeSheetSchema = z.object({
    project_id: z.string().uuid(),
    supplier_id: z.string().uuid(),
    client_id: z.string().uuid(),
    start_time: z.string().date(),
    end_time: z.string().date(),
});

export type GenerateTimeSheetSchema = z.infer<typeof GenerateTimeSheetSchema>;

export const SaveTimeSheetSchema = z.object({
    title: z.string(),
    description: z.string(),
    status: z.enum([
        "DRAFTED",
        "TO_BE_VERIFIED",
        "VERIFIED",
        "APPROVED",
        "REJECTED",
    ]),
    note: z.string(),
    other_deductions: z.number().min(0, "Minimum value is 0"),
    deduction_note: z.string(),
});

export type SaveTimeSheetSchema = z.infer<typeof SaveTimeSheetSchema>;
